import { render, staticRenderFns } from "./NevronFooter.vue?vue&type=template&id=509b9ddc&"
import script from "./NevronFooter.vue?vue&type=script&lang=ts&"
export * from "./NevronFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports